<script setup>
import {useTitle} from "@vueuse/core";
import {useI18n} from "vue-i18n";

import { log } from 'taxi-lib'

const { t } = useI18n();
useTitle(t('receipt.start.page_title'))

</script>

<template>
  <div class="h-full w-full relative overflow-auto">
    <router-view></router-view>
  </div>
</template>
